"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Status = exports.Quantity = exports.Price = exports.OrderType = exports.DepositWithdrawQuantity = exports.DateTime = exports.CancelAction = exports.Amount = exports.Action = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _APIcon = _interopRequireDefault(require("../common/APIcon"));
var _ProductIconContainer = _interopRequireDefault(require("../common/ProductIcon/ProductIconContainer"));
var _CancelAPButton = _interopRequireDefault(require("../common/CancelAPButton"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _numberFormatter = require("../../helpers/numberFormatter");
var _dateHelper = require("../../helpers/dateHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('activity');
var getIcon = function getIcon(props) {
  if (props.TransactionType === 'LiquidationFee') {
    return 'withdraw'; // LiquidationFee is always a debit (charge)
  }
  if (props.TransactionType === 'InterestAccrued') {
    return 'withdraw'; // InterestAccrued is always a debit (interest owed on borrowed funds)
  }
  switch (props.ReferenceType) {
    case 'Transfer':
    case 'Trade':
      {
        return props.CR ? 'deposit' : 'withdraw';
      }
    case 'Withdraw':
      return 'withdraw';
    case 'Deposit':
      return 'deposit';
    default:
      return '';
  }
};
var getPrimaryText = function getPrimaryText(props, t) {
  // Check TransactionType first for special cases
  if (props.TransactionType === 'LiquidationFee') {
    return t('Liquidation Fee ({{a}})', {
      a: props.Product1Symbol || props.Product
    });
  }
  if (props.TransactionType === 'InterestAccrued') {
    return t('Interest Accrued ({{a}})', {
      a: props.Product1Symbol || props.Product
    });
  }
  switch (props.ReferenceType) {
    case 'Trade':
      {
        if (props.TransactionType === 'Fee') {
          return t('Trade Fee ({{a}})', {
            a: props.Product1Symbol
          });
        }
        return props.CR ? t('Bought {{a}}', {
          a: props.Product1Symbol
        }) : t('Sold {{a}}', {
          a: props.Product1Symbol
        });
      }
    case 'Deposit':
      {
        if (props.TransactionType === 'Fee') {
          return t('Deposit Fee ({{a}})', {
            a: props.Product
          });
        }
        return t('Deposited {{a}}', {
          a: props.Product
        });
      }
    case 'Withdraw':
      {
        if (props.TransactionType === 'Fee') {
          return t('Withdraw Fee ({{a}})', {
            a: props.Product
          });
        }
        return t('Withdrew {{a}}', {
          a: props.Product
        });
      }
    case 'Transfer':
      {
        return props.CR ? t('Received {{a}}', {
          a: props.Product1Symbol
        }) : t('Sent {{a}}', {
          a: props.Product1Symbol
        });
      }
  }
};
var Action = exports.Action = function Action(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('activity'),
    t = _useTranslation.t;
  var showProductIcon = props.showProductIcon,
    themeModifier = props.themeModifier;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('action')
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: getIcon(props),
    customClass: baseClasses('type-icon')
  }), showProductIcon && /*#__PURE__*/_react["default"].createElement(_ProductIconContainer["default"], {
    customClass: baseClasses('product-icon', themeModifier),
    iconFileName: props.iconFileName,
    size: 36
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('action-column')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('action-text', 'primary')
  }, getPrimaryText(props, t))));
};
var Amount = exports.Amount = function Amount(props) {
  var Quantity = props.DR ? props.DR : props.CR;
  var Product1Symbol = props.Product1Symbol;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('amount')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('amount-quantity')
  }, "".concat((0, _numberFormatter.formatNumberToLocale)(Quantity, Product1Symbol), " ").concat(Product1Symbol)));
};
var Status = exports.Status = function Status(props) {
  var customClass = props.customClass;
  var status = '';
  if (props.TransactionType === 'Trade') {
    status = 'Complete';
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(customClass, " ").concat(baseClasses('status'))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('status-id')
  }, props.ReferenceId), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('status-text')
  }, status));
};
var DateTime = exports.DateTime = function DateTime(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('date')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('date-date')
  }, (0, _dateHelper.formatDate)(props.TimeStamp)), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('date-time')
  }, (0, _dateHelper.formatTime)(props.TimeStamp)));
};
var OrderType = exports.OrderType = function OrderType(props) {
  var _useTranslation2 = (0, _reactI18next.useTranslation)('activity'),
    t = _useTranslation2.t;
  var orderType = props.value;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('order-type')
  }, t(orderType));
};
var Quantity = exports.Quantity = function Quantity(props) {
  var _props$value = props.value,
    OrigQuantity = _props$value.OrigQuantity,
    Product1Symbol = _props$value.Product1Symbol;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('quantity')
  }, (0, _numberFormatter.formatNumberToLocale)(OrigQuantity, OrigQuantity.symbol), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('quantity-text')
  }, Product1Symbol));
};
var DepositWithdrawQuantity = exports.DepositWithdrawQuantity = function DepositWithdrawQuantity(props) {
  return Quantity({
    value: {
      OrigQuantity: props.value.Quantity,
      Product1Symbol: props.value.Product1Symbol
    }
  });
};
var Price = exports.Price = function Price(props) {
  var _props$value2 = props.value,
    Price = _props$value2.Price,
    Product2Symbol = _props$value2.Product2Symbol;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('price')
  }, (0, _numberFormatter.formatNumberToLocale)(Price, Price.symbol), " ", Product2Symbol);
};
var CancelAction = exports.CancelAction = function CancelAction(props) {
  var _useTranslation3 = (0, _reactI18next.useTranslation)('activity'),
    t = _useTranslation3.t;
  var orderId = props.value;
  var cancelOrders = props.action;
  return /*#__PURE__*/_react["default"].createElement(_CancelAPButton["default"], {
    text: t('Cancel Order'),
    customClass: baseClasses(),
    onClick: function onClick() {
      cancelOrders([orderId]);
    }
  });
};
Status.defaultProps = {
  customClass: ''
};